export default "__VITE_ASSET__Ca6dcnz3__"